export enum ChatOption {
  NONE = 0,
  CHAT = 1,
  HISTORY = 2,
}

export enum AiAgentChatType {
  AgenteQR = 1,
  LiveChat = 2,
}
